import type { ReactElement } from 'react'
import { useRef } from 'react'
import { useStore } from 'react-redux'

import { allowedMimeTypes, imageUrl, storeFile } from '../templateComponents/Workspace/daliConfig'

type Props = {
  path: string
  setPath: (path: string) => void
  onUploadSuccess: () => void
  onError: (error: any) => void
}

export default function LogoUpload({ path, setPath, onUploadSuccess, onError }: Readonly<Props>): ReactElement {
  const store: any = useStore()
  const ref = useRef<HTMLInputElement>(null)
  const upload = storeFile(store.api)
  const onUpload = (file: File) => {
    upload(file).then((response: any) => {
      onUploadSuccess()
      setPath(imageUrl(store.getState().getIn(['shop', 'slug']))(response.absoluteDownloadUrl))
    }, onError)
  }

  return (
    <>
      <span onClick={() => ref.current?.click()} className="ep-custom-settings-item-upload-image">
        <img src={path} />
      </span>
      <input
        ref={ref}
        type="file"
        data-testid="fileInput"
        accept={allowedMimeTypes.join(',')}
        onChange={(event) => event.target.files?.[0] && onUpload(event.target.files[0])}
      />
      <input type="hidden" name="path" value={path} />
    </>
  )
}
